module.exports = __webpack_public_path__ + "c7f7fb0a67f1a2fbd0d753478a90f317.png";